function foldedStyles(ratio) {
  let styles;
  const orientation = ratio > 1 ? 'landscape' : 'portrait';

  switch (orientation) {
    case 'landscape':
      styles = {
        left: '100%',
        width: '8%',
        "max-height": 'inherit'
      }
      break;
    case 'portrait':
      styles = {
        width: '100%',
        height: 'auto',
        top: '-5%',
        "max-height": 'inherit'
      }
      break;
  }

  return styles;
}

function cornerStyles(ratio) {
  let styles;
  const orientation = ratio > 1 ? 'landscape' : 'portrait';

  switch (orientation) {
    case 'landscape':
      styles = {
        width: '100%',
        "max-height": 'inherit'
      }
      break;
    case 'portrait':
      styles = {
        height: '100%',
        width: '100%',
        "max-height": 'inherit'
      }
      break;
  }

  return styles;
}

function foldedSrc(ratio) {
  let backgroundImage;
  const orientation = ratio > 1 ? 'landscape' : 'portrait';

  switch (orientation) {
    case 'landscape':
      backgroundImage = '/stylesheets/walmart/images/fake_folded_card_backs/landscape.png';
      break;
    case 'portrait':
      backgroundImage = '/stylesheets/walmart/images/fake_folded_card_backs/portrait.png';
      break; 
  }

  return backgroundImage;
}

function roundedSrc(ratio) {
  return `/stylesheets/walmart/images/rounded_corners/ratio_${ratio}.svg`;
}

function maskSrc(cornerType, ratio) {
  const getSVGSource = (cornerType, ratio) => {
    const imageOrientation = ratio > 1 ? 'landscape' : 'portrait';
    return `/stylesheets/walmart/images/scalloped_edges_and_elegant_corners/5x7_${cornerType.replace(
      'ed',
      ''
    )}_mask_${imageOrientation}.svg`;
  };
  const SVGSource = getSVGSource(cornerType, ratio);

  return SVGSource;
}
export { cornerStyles, foldedStyles, foldedSrc, roundedSrc, maskSrc };
